import React from 'react';
import classNames from 'classnames';

const colorClass = {
  primary: 'bg-primary/10 text-primary border-primary/30',
  secondary: 'bg-gray-200 text-gray-800 border-gray-300',
  success: 'bg-success/10 text-success border-success/30',
  info: 'bg-info/10 text-info border-info/30',
  warning: 'bg-warning/10 text-warning border-warning/30',
  danger: 'bg-danger/10 text-danger border-danger/30',
  light: 'bg-light text-gray-700 border-gray-300',
  dark: 'bg-gray-900 text-white border-gray-900',
};

export function Alert({
  color = 'success',
  isOpen = true,
  toggle,
  children,
  className,
  fade,
  tag: Tag = 'div',
  ...rest
}) {
  if (!isOpen) return null;
  return (
    <Tag
      role="alert"
      {...rest}
      className={classNames(
        'relative mb-4 border px-5 py-3',
        colorClass[color] || colorClass.success,
        toggle && 'pr-10',
        className
      )}
    >
      {children}
      {toggle && (
        <button
          type="button"
          aria-label="Close"
          onClick={toggle}
          className="absolute right-3 top-2 cursor-pointer border-0 bg-transparent p-1 text-xl leading-none text-current opacity-60 hover:opacity-100"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </Tag>
  );
}
